import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AutosizeModule } from 'ngx-autosize';
import { IonicStorageModule } from '@ionic/storage-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from "./components/components.module";
import { AlertService } from './providers/alert/alert.service';
import { HelperService } from "./providers/helper/helper.service";
import { LocalStorageService } from './providers/local-storage/local-storage.service';
import { ParserService } from "./providers/parser/parser.service";
import { RequestProviderService } from './providers/request-provider/request-provider.service';
import { TokenInterceptorService } from "./providers/token-interceptor/token-interceptor.service";
import { environment } from '../environments/environment';
import { RequestHelperService } from './providers/request-helper/request-helper.service';
import { PermissionManager } from './components/permission-manager/permission-manager.component';
import { SensingService } from './providers/sensing-service/sensing-service.service';
import { FileDownloader } from './components/file-downloader/file-downloader.component';
import { CancelableLoading } from './components/dialogs/cancelable-loading/cancelable-loading.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        BrowserModule,
        ComponentsModule,
        IonicModule.forRoot({ swipeBackEnabled: false }),
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        AutosizeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        BrowserAnimationsModule,
        FontAwesomeModule], providers: [
        AlertService,
        HelperService,
        LocalStorageService,
        ParserService,
        RequestProviderService,
        TokenInterceptorService,
        RequestHelperService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
        PermissionManager,
        SensingService,
        FileDownloader,
        AppComponent,
        CancelableLoading,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule {
  public darkTheme = true;
  constructor() { }
}
